import { selectAllCompanyUsersById } from "app/containers/Global/slice";
import WarningModal from "app/storybookComponents/Modals/WarningModal";
import { useAppSelector } from "utils/redux/hooks";
import { WEEKLY_CHECK_IN_FEATURE_NAME } from "../constants";

interface Props {
  onHide: () => void;
  onConfirmClick: () => void;
  isInProgress?: boolean;
  userAccountId?: number | null;
}

const SendPendingReminderModal = ({
  onConfirmClick,
  onHide,
  isInProgress,
  userAccountId,
}: Readonly<Props>) => {
  const usersById = useAppSelector(selectAllCompanyUsersById);
  const user = userAccountId ? usersById[userAccountId] : null;
  const userFirstName = user?.firstName ?? "User";

  return (
    <WarningModal
      modalTitle="Send Reminder"
      hideModal={onHide}
      isOpen={!!userAccountId}
      onConfirmClick={onConfirmClick}
      warningTitle={`Remind ${userFirstName} to complete the ${WEEKLY_CHECK_IN_FEATURE_NAME}?`}
      warningMessage={`Send an email reminder to ${userFirstName} to complete their Check-In.`}
      customButtonText="Send Reminder"
      isDanger={false}
      isInProgress={isInProgress}
    />
  );
};
export default SendPendingReminderModal;
